module.exports = __webpack_public_path__ + "img/icon-8.97e3c10f.png";